import { testRegex, REGEX } from "@/backend/lib/regex";
import { ObjectProperty } from "@/backend/models/objectInstance";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { FileSubjectTypes } from "@/types/fileTypes";
import { UpdatedParamsAndRefs } from "@/types/parameterTypes";
import { useState, useEffect } from "react";
import { FileUploader } from "../../files/FileUploader";
import { Form } from "react-bootstrap";

export function ObjectValueEditForm(props: { property: ObjectProperty, handleUpdatedConsumers: (response: UpdatedParamsAndRefs) => void, disabled?: boolean }) {
  const { property, handleUpdatedConsumers, disabled } = props;

  const consumerReference = useParameterStore(state => state.references.find(ref => ref.consumerObjectKeyId === property.keyId ));

  const isDisabled = !!consumerReference || disabled;

  const updateObjectValue = useParameterStore(state => state.updateObjectValue);
  const [value, setValue] = useState(property.value?.toString() || '');
  const [valueError, setValueError] = useState('');

  useEffect(() => {
    setValue(property.value?.toString() || '');
  }, [property.value]);

  const onChange = (newValue: string) => {
    setValue(newValue);
    setValueError('');
    if (newValue && !testRegex(REGEX[property.type], newValue)) {
      setValueError(I18n.get('invalidCustomFieldInput', { type: I18n.get(property.type) }));
    }
  };

  if (property.type === CUSTOM_FIELD_TYPES.Boolean) {
    return (
    <Form.Select
      size='sm' defaultValue={(value || 'false') as string}
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => void updateObjectValue({ id: property.valueId, value, objectKeyId: property.keyId }, handleUpdatedConsumers)}
      disabled={isDisabled}
      className="form-control-white"
    >
      <option value='true'>{I18n.get('true')}</option>
      <option value='false'>{I18n.get('false')}</option>
    </Form.Select>
    );
  }

  if (property.type === CUSTOM_FIELD_TYPES.File) {
    return (
      <FileUploader
        subjectId={property.valueId}
        subjectType={FileSubjectTypes.OBJECT_VALUE}
        refetchSubject={(response) => handleUpdatedConsumers({ updatedEquipment: [], ...response })}
        file={property.file}
        readOnly={isDisabled}
        hideFilePreview
        allowCapture={false}
        />
    );
  }

  return (
    <>
      <Form.Control
        size='sm'
        aria-label={I18n.get('enterField', { field: I18n.get('value') })}
        value={value as string}
        isInvalid={!!valueError}
        type='text'
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => void updateObjectValue({ id: property.valueId, value, objectKeyId: property.keyId }, handleUpdatedConsumers)}
        disabled={isDisabled}
        className="form-control-white"
      />
      <Form.Control.Feedback type="invalid">
        { valueError }
      </Form.Control.Feedback>
    </>
  );
}
